import "../../lib/form/form.scss";
import "../Main.scss";
import Sub from "../Sub";
import "./Notice.scss";

import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import Pagination from "react-js-pagination";
import { Route, Routes, useNavigate } from "react-router-dom";
import ConfirmModal from "../../components/ConfirmModal";
import NoticeDetail from "./NoticeDetail";

function Announcement() {
  const [annAlways, setAnnAlways] = useState([]);
  const [annNum, setAnnNum] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [filterType, setFilterType] = useState("init");
  const [filterInput, setFilterInput] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [filterValidateModal, setFilterValidateModal] = useState(false);

  // 검색 필터 타입
  const onChangeFilterType = (e) => {
    // console.log(e.target.value);
    setFilterType(e.target.value);
  };
  const onChangeFilterInput = (e) => {
    // console.log(e.target.value);
    setFilterInput(e.target.value);
  };

  const onClickFilter = () => {
    // console.log(`onClick filterType = ${filterType}`);
    // console.log(`onClick filterInput = ${filterInput}`);
    if (filterType === "init") {
      setFilterModal(true);
      setFilterInput("");
      posts();
    } else if (filterType === "titleLike" && filterInput.length === 0) {
      setFilterValidateModal(true);
    } else if (filterType === "writerLike" && filterInput.length === 0) {
      setFilterValidateModal(true);
    } else {
      setPage(0);
      PageFilterReplace();
    }
  };

  const PageFilterReplace = () => {
    // console.log(`page = ${page}`);
    posts();
  };

  let navigate = useNavigate();

  const handlePageChange = (page) => {
    posts(page);
    setPage(page);
  };
  const openModal = (e) => {
    e.preventDefault();
    setFilterModal(true);
  };
  const closeModal = (e) => {
    e.preventDefault();
    setFilterModal(false);
    setFilterValidateModal(false);
  };

  // 날짜 => 상시
  useEffect(() => {
    const toDate = moment().format(moment.HTML5_FMT.DATE);
    axios
      .get("/api/board", {
        params: {
          pageNumber: 1,
          type: 2,
          pageSize: 3,
          // state: 2,
        },
      })
      .then((response) => {
        const filteredArr = response.data.data.filter(
          (el) =>
            moment(toDate).isBetween(
              el.startDate,
              el.endDate,
              undefined,
              "[]"
            ) === true
        );
        setAnnAlways(filteredArr);
      });
  }, []);

  let posts = function (pageNum) {
    if (pageNum === undefined) pageNum = 1;
    let params = { pageNumber: pageNum, type: 2, pageSize: 15 };

    if (filterType !== "init") {
      params[filterType] = filterInput;
    }
    axios
      .get("/api/board", {
        params: params,
      })
      .then((response) => {
        setAnnNum(response.data.data);
        setRecords(response.data);
        setTotalItems(response.data.recordsFiltered);
      });
  };

  // 날짜 => 숫자, 상시
  useEffect(() => {
    posts();
  }, []);

  return (
    <>
      {filterModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색 필터"}
          content={`검색 필터를 선택해 주세요.`}
        />
      ) : null}
      {filterValidateModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색어 입력"}
          content={`검색어를 입력해 주세요.`}
        />
      ) : null}
      <Sub to={"/announcement"} title="공고" />
      <div className="">
        <div className=" ">
          <form className="my_page bbs_contain" action="" method="">
            <div className="row_bbs">
              <div className="select_box">
                <select
                  defaultValue={"init"}
                  name="fruites"
                  onChange={onChangeFilterType}
                >
                  <option value="init" disabled>
                    검색필터
                  </option>
                  <option value="titleLike">제목</option>
                  <option value="writerLike">작성자</option>
                </select>
              </div>

              <div className="input_wrap">
                <input
                  className="input_box"
                  type="text"
                  placeholder="검색어를 입력하세요."
                  value={filterInput}
                  onChange={onChangeFilterInput}
                />
                <button
                  className="btn_color"
                  type="button"
                  onClick={onClickFilter}
                >
                  <FiSearch />
                </button>
              </div>
            </div>

            <Routes>
              <Route path=":id" element={<NoticeDetail />} />
            </Routes>

            <div className="row_bbs bbs_wrap">
              <table className="table_wrap">
                <thead>
                  <tr>
                    <th>번호</th>
                    <th>글제목</th>
                    <th>작성자</th>
                    <th>작성일자</th>
                  </tr>
                </thead>

                <tbody>
                  {annAlways.map((annAlwaysInfo) => {
                    // 게시글 번호 => 상시
                    return (
                      <tr className="tr_hover2" key={annAlwaysInfo.id}>
                        <td className="num_bbs">상시</td>
                        <td
                          onClick={() => {
                            window.scrollTo(0, 0);
                            navigate(`/announcement/${annAlwaysInfo.id}`);
                          }}
                        >
                          <p>{annAlwaysInfo.title}</p>
                        </td>
                        <td>
                          <p className="auth">{annAlwaysInfo.writer}</p>
                        </td>
                        <td className="date_bbs">
                          {annAlwaysInfo.startDate
                            ?.substring(0, 11)
                            .replace(/-/g, ".")}
                        </td>
                      </tr>
                    );
                  })}
                  {annNum.map((annNumInfo) => {
                    // 게시글 번호 => 숫자, 상시
                    return (
                      <tr className="tr_hover" key={annNumInfo.id}>
                        <td className="num_bbs">{annNumInfo.orderNum}</td>
                        <td>
                          <p
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(`/announcement/${annNumInfo.id}`);
                            }}
                          >
                            {annNumInfo.title}
                          </p>
                        </td>
                        <td>
                          <p className="auth">{annNumInfo.writer}</p>
                        </td>
                        <td className="date_bbs">
                          {(annNumInfo.startDate || annNumInfo.createAt)
                            ?.substring(0, 11)
                            .replace(/-/g, ".")}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {annAlways.length > 0 || annNum.length > 0 ? null : (
                <span style={{ textAlign: "center", marginTop: "10vh" }}>
                  등록된 목록이 없습니다
                </span>
              )}
              <div className="pagination_wrap">
                <div></div>

                <div className="pagination">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={15}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={15}
                    onChange={handlePageChange}
                    prevPageText={"‹"}
                    nextPageText={"›"}
                  />
                </div>
                <div>
                  {/* <button
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/announcement");
                    }}
                    className="list_btn"
                  >
                    목록
                  </button> */}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Announcement;
